import { render, staticRenderFns } from "./Heatmap.vue?vue&type=template&id=fee9ff00&scoped=true&"
import script from "./Heatmap.vue?vue&type=script&lang=js&"
export * from "./Heatmap.vue?vue&type=script&lang=js&"
import style0 from "./Heatmap.vue?vue&type=style&index=0&id=fee9ff00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee9ff00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fee9ff00')) {
      api.createRecord('fee9ff00', component.options)
    } else {
      api.reload('fee9ff00', component.options)
    }
    module.hot.accept("./Heatmap.vue?vue&type=template&id=fee9ff00&scoped=true&", function () {
      api.rerender('fee9ff00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/reports/components/Heatmap.vue"
export default component.exports